import React from "react";
import LandingPage from "view/home/landing-page";

const Home = () => <LandingPage />;

export default Home;
